export type QueryParameterOptions =
	| 'geo_country'
	| 'subdivision'
	| 'sr'
	| 'holdout'
	| 'sr_ad_id'
	| 'sr_testing'
	| 'sr_keep'
	| 'jw-pro'
	| 'sr_sc'
	| 'sr_locale'
	| 'no_index_debug';

/**
 * A non-vue way to get the query paramater
 * Useful for when we need the query parameter before Vue is initalised
 *
 * @param urlQueryKey: urlQueryKey
 * @returns The value of the Query Key
 */
export function getUrlQueryParameters(urlQueryKey: QueryParameterOptions) {
	const urlParams = import.meta.server ? useRequestURL().searchParams : new URLSearchParams(window.location.search);

	return urlParams.get(urlQueryKey);
}

// temp solution to set debug params in session storage in meta.store
export function storeNoIndexDebug() {
	if (!import.meta.client) return;

	const noIndexDebug = getUrlQueryParameters('no_index_debug');

	if (noIndexDebug) {
		localStorage.setItem('no_index_debug', noIndexDebug);
	}
	if (noIndexDebug === 'false') {
		localStorage.removeItem('no_index_debug');
	}
}
